export class SorszamHelper {
    static #egyesek = ["nulladik", "első", "második", "harmadik", "negyedik", 
                       "ötödik", "hatodik", "hetedik", "nyolcadik", "kilencedik"];
    static #tizesek = ["tizedik", "huszadik", "harmincadik", "negyvenedik", 
                       "ötvenedik", "hatvanadik", "hetvenedik", "nyolcvanadik", 
                       "kilencvenedik"];

    /**
     * Számot szöveges sorszámra alakít.
     *
     * @param {number} szam A szám, amit sorszámként szeretnénk megjeleníteni.
     * @returns {string} A szám szöveges sorszámként.
     */
    static szamotSzovegesre(szam) {
        if (szam < 10) {
            return this.#egyesek[szam] || `${szam}.`;
        } else if (szam < 100) {
            // Nem tökéletes, jobb mint a semmi
            const tizes = Math.floor(szam / 10) - 1;
            const egyes = szam % 10;

            if (egyes === 0) {
                return this.#tizesek[tizes] || `${szam}.`;
            } else {
                const tizesResz = this.#tizesek[tizes] || '';
                const egyesResz = this.#egyesek[egyes] || '';
                return tizesResz.slice(0, -4) + egyesResz;
            }
        } else {
            return `${szam}.`;
        }
    }
}
